import { render } from "./DirectPurchaseDetails.vue?vue&type=template&id=0d5fa1ca"
import script from "./DirectPurchaseDetails.vue?vue&type=script&lang=js"
export * from "./DirectPurchaseDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__